/** Reduced 1D periodic scalar PLM model, not the production 3D Hydro port. */
export function plmStep(q: number[], courant: number): number[] {
  const n = q.length;
  const at = (i: number) => q[(i + n) % n];
  const edge = q.map((v, i) => {
    const left = v - at(i - 1), right = at(i + 1) - v;
    const slope = left * right <= 0 ? 0 : Math.sign(left) * Math.min(Math.abs(left), Math.abs(right));
    return v + .5 * (1 - courant) * slope;
  });
  return q.map((v, i) => v - courant * (edge[i] - edge[(i - 1 + n) % n]));
}
export function diffusionAmplification(z: number) {
  return { exact: Math.exp(-z), cn: (1 - z / 2) / (1 + z / 2), backwardEuler: 1 / (1 + z) };
}
export function gridCounts(nx: number, ny: number, ghosts: number) {
  return { cells: nx * ny, nodes: (nx + 1) * (ny + 1), xFaces: (nx + 1) * ny, yFaces: nx * (ny + 1), allocated: (nx + 2 * ghosts) * (ny + 2 * ghosts) };
}
